import { type StackProps, type TypographyProps, useTheme } from "@mui/material"
import type { ReactElement, ReactNode } from "react"
import type { Icon } from "react-feather"
import type { IconUrl } from "../../../icons"
import type { IconUrlContainerProps } from "../../../icons/IconUrls/IconUrlContainer"
import {
  BottomLabel,
  Container,
  LabelsContainer,
  OuterContainer,
  Title,
  TopLabel,
} from "../commons"

export interface LinkBoxProps {
  leftIcon: Icon | IconUrl
  RightIcon: ReactElement
  title: ReactNode
  topLabel?: string
  bottomLabel?: string
  leftIconSize?: number
  slotProps?: SlotProps
}

interface SlotProps {
  title?: TypographyProps
  topLabel?: TypographyProps
  bottomLabel?: TypographyProps
  labelsContainer?: StackProps
  container?: StackProps
  outerContainer?: StackProps
  leftIcon?: Omit<IconUrlContainerProps, "url">
}

export const LinkBox = ({
  leftIcon: LeftIcon,
  RightIcon,
  title,
  topLabel,
  bottomLabel,
  leftIconSize = 34,
  slotProps,
}: LinkBoxProps) => {
  const { typography } = useTheme()
  return (
    <OuterContainer {...slotProps?.outerContainer}>
      <Container {...slotProps?.container}>
        <LeftIcon size={typography.pxToRem(leftIconSize)} {...slotProps?.leftIcon} />

        <LabelsContainer {...slotProps?.labelsContainer}>
          <TopLabel {...slotProps?.topLabel}>{topLabel}</TopLabel>
          <Title {...slotProps?.title}>{title}</Title>
          <BottomLabel {...slotProps?.bottomLabel}>{bottomLabel}</BottomLabel>
        </LabelsContainer>
      </Container>

      {RightIcon}
    </OuterContainer>
  )
}
